<template>
  <div class="driver-list">
    <div class="tabs">
      <a :class="{ tab: true, active: activeTab === 0 }" @click="activeTab = 0">ON-DUTY DRIVERS</a>
      <a :class="{ tab: true, active: activeTab === 1 }" @click="activeTab = 1">STAGING DRIVERS</a>
      <a :class="{ tab: true, active: activeTab === 2 }" @click="activeTab = 2">OFF-DUTY DRIVERS</a>
      <a :class="{ tab: true, active: activeTab === 3 }" @click="activeTab = 3">AVAILABILITY</a>
    </div>

    <driver-list-filters v-show="activeTab !== 1 && activeTab !== 3"></driver-list-filters>

    <div id="driver-list-container" :class="['tab-content-container', {'staging-drivers': activeTab === 1 || activeTab === 3, 'extend':currentDispatchTab === 3 }]">
      <div :class="{ 'tab-content': true, active: activeTab === 0 }">
        <driver-table :onDuty="true" :staging="false" ref="onDuty"></driver-table>
      </div>

      <div :class="{ 'tab-content': true, active: activeTab === 1 }">
        <!--driver-table :onDuty="true" :staging="true"></driver-table-->
        <staging-drivers></staging-drivers>
      </div>

      <div :class="{ 'tab-content': true, active: activeTab === 2 }">
        <driver-table :onDuty="false" :staging="false" ref="offDuty"></driver-table>
      </div>

      <div :class="{ 'tab-content': true, active: activeTab === 3 }">
        <!--driver-table :onDuty="true" :staging="true"></driver-table-->
        <driver-availability ref="driverAvailability"></driver-availability>
      </div>
    </div>

    <driver-controls :tabIndex="tabIndex"></driver-controls>
  </div>
</template>

<script>
import moment from 'moment'
import ApiDispatchDrivers from '@/modules/api/dispatch/drivers'
import DriverAvailability from './DriverAvailability'
import DriverControls from './DriverControls'
import DriverListFilters from './DriverListFilters'
import DriverTable from './DriverTable'
import StagingDrivers from './StagingDrivers'

export default {
  name: 'available-drivers',
  components: { DriverAvailability, DriverControls, DriverListFilters, DriverTable, StagingDrivers },
  props: ['tabIndex'],
  computed: {
    currentDispatchTab () { return this.$store.state.dispatch.currentTable },
    rsvpInMap () { return this.$store.state.dispatch.rsvpInMap },
    activeTab: {
      get () { return this.$store.state.dispatch.driverListTabIndex },
      set (value) {
        // if (value === 0) {
        //   if (this.$refs.onDuty.loadPage()) {
        //     this.$refs.onDuty.loadPage()
        //   }
        // }
        // if (value === 2) {
        //   if (this.$refs.offDuty.loadPage()) {
        //     this.$refs.offDuty.loadPage()
        //   }
        // }
        this.$store.commit('dispatch/setDriverListTabIndex', value)
      }
    },
    reloadDrivers () { return this.$store.state.dispatch.reloadDrivers }
  },
  methods: {
    checkDriverTab () {
      if (this.activeTab === 3) {
        if (this.$refs.driverAvailability) {
          this.$refs.driverAvailability.checkRunAvailability()
        }
      }
    },
    activeTabLabel (x) {
      switch (x) {
        case 0: return 'onDuty'
        case 1: return 'staging'
        case 2: return 'offDuty'
        case 3: return 'availability'
      }
    }
  },
  watch: {
    rsvpInMap (value) {
      if (value.id === null) {
        return
      }
      if (value.status !== 'UPCOMING' && value.status !== 'REQUIRES DISPATCH') {
        return
      }
      let now = moment()
      let pickupTime = moment(value.pickupTime, 'MM/DD/YYYY hh:mmA')
      let diff = pickupTime.diff(now, 'minute')
      let limit = parseInt(this.$settings.get('findNearbyDriverLimit'))
      if (diff > limit) {
        this.$store.commit('dispatch/setDriverListTabIndex', 3)
      }
      if (this.activeTab == 3) {
        if (this.$refs.driverAvailability) {
          this.$refs.driverAvailability.checkAvailability()
        }
      }
    },
    reloadDrivers (value) {
      if (value) {
        this.$store.commit('dispatch/setReloadDrivers', false)
        if (this.$refs.onDuty.loadPage()) {
          this.$refs.onDuty.loadPage()
        }
        if (this.$refs.offDuty.loadPage()) {
          this.$refs.offDuty.loadPage()
        }
      }
    },
    activeTab (x) {
      // if (x == 3) {
      //   if (this.$refs.driverAvailability) {
      //     this.$refs.driverAvailability.checkAvailability()
      //   }
      // }
      this.$store.commit('dispatch/setTabActiveData', {driver: this.activeTabLabel(x)})
    }
  },
  mounted () {
    // let self = this
    // ApiDispatchDrivers.getOnDutyDrivers(self)
    // ApiDispatchDrivers.getOffDutyDrivers(self)
  }
}
</script>

<style lang="scss" scoped>

.tabs {
  display: block;
  width: 100%;

  a{
    cursor: pointer;
  }
  & .tab{
    display: block;
    width: calc(100% / 4);
    float: left;
    text-align: center;
    padding: 15px;
    font-size: 12px;
    font-weight: 700;
    background-color: #e5e5e5;
    border-bottom: 1px solid rgba(0,0,0,0.2);
    transition: all 250ms;
    text-decoration: none;

    &.active{
      background-color: #fff;
      border-left: 1px solid rgba(0,0,0,0.2);
      border-right: 1px solid rgba(0,0,0,0.2);
      border-bottom: 1px solid #fff;
      pointer-events: none;
    }
  }
}

.tab-content-container {
  position: absolute;
  top: 257px; left: 0;
  width: 100%;
  height: calc(100% - 268px - 107px);
  background-color: #f5f5f5;
  border: 1px solid rgba(0,0,0,0.2);
  padding: 15px;
  overflow-y: auto;

  &.extend{
    height: calc(100% - 200px - 107px);
  }
  & .tab-content{
    display: none;

    & table{
      margin: 0 auto;
    }

    &.active{
      display: block;
    }
  }

  &.staging-drivers {
    top: 49px;
    border-top: 0;
    background-color: #fff;
    height: calc(100% - 49px - 107px);
  }
}

@media only screen and (max-width: 430px) {
  .tabs {
    display: flex;
    overflow-x: scroll;
    & .tab{
      width: auto;
      flex-shrink: 0;
    }
  }

  .tab-content {
    padding-bottom: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dispatch/AvailableDrivers.vue